import React from "react";
import { Bar } from "react-chartjs-2";
import { getGraphTitleFromGraphOptions } from "../Utils";

function getAverage(graphData) {
    const sumPerDay = graphData.data;
    const avg = sumPerDay.reduce((sum, item) => sum + item.value + item.value2, 0) / sumPerDay.length;
    return avg;
}

function getTagsFromGraphData(graphData) {
    return graphData.data.map(row => row.tag);
}

function getValuesFromGraphData(graphData) {
    return graphData.data.map(row => row.value);
}

export default function BarChart({ graphData, desiredGraphOptions }) {
    const data = {
        labels: getTagsFromGraphData(graphData),
        datasets: [
            {
                label: 'Total',
                data: getValuesFromGraphData(graphData)
            }
        ]
    }

    const avg_annotation = {
        type: 'line',
        borderColor: 'black',
        borderDash: [6, 6],
        borderDashOffset: 0,
        borderWidth: 2,
        label: {
            display: true,
            content: 'Average: ' + getAverage(graphData).toFixed(2),
            position: 'end',
        },
        scaleID: 'y',
        value: getAverage(graphData)
    }

    const options = {
        animation: true,
        maintainAspectRatio: false,
        plugins: {
            legend: {
                display: false
            },
            tooltip: {
                enabled: true
            },
            title: {
                display: true,
                text: getGraphTitleFromGraphOptions(desiredGraphOptions)
            },
            annotation: {
                annotations: {
                    avg_annotation
                }
            }
        }
    }

    return <Bar options={options} data={data} />;
}